<template>
    <div class="body">
      <div class="header">
        <el-form :model="PieceworkSetFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="产品名称">
              <el-input
                v-model="PieceworkSetFindDTO.category"
                placeholder="产品名称"
              ></el-input>
            </el-form-item>
          <el-form-item label="工序">
              <el-input
                v-model="PieceworkSetFindDTO.productionProcesses"
                placeholder="工序"
              ></el-input>
            </el-form-item>
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <br>
          <el-form-item>
            <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增计件设置"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >

          <el-form-item label="产品名称" prop="category">
                            <el-select clearable size="small" v-model="accountForm.category" allow-create
                                       filterable
                                        @blur.native.capture="categorySelect">
                                <el-option
                                    v-for="item in category"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
 
    <el-form-item  label="工序" prop="productionProcesses">
          <el-input
            class="input-remark"
            
            v-model="accountForm.productionProcesses"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-form-item >
            <el-button
              
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑计件设置" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
         
     
        <el-form-item label="产品名称" prop="category">
                            <el-select clearable size="small" v-model="accountForm.category" allow-create
                                       filterable
                                        @blur.native.capture="categorySelect">
                                <el-option
                                    v-for="item in category"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
 
    <el-form-item  label="工序" prop="productionProcesses">
          <el-input
            class="input-remark"
            
            v-model="accountForm.productionProcesses"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button  type="primary" @click="editAccount()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
          <el-table-column
            prop="category"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            prop="productionProcesses"
            align="center"
            label="工序"
  
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="单价"
          ></el-table-column>
   
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
  

    </div>
  </template>
  
  <script>
  import { selectPieceworkSet,bathDeletePieceworkSet,addPieceworkSet,upPieceworkSet ,getAllCategory} from '@/api/order/piecework.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        PieceworkSetFindDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            productionProcesses:''
        },
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          category:'',
          productionProcesses:'',
          price:'',
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
          category:[
                    { required: true, message: '请输入产品名称', trigger: 'blur' }]
           
            }

      }
    },
    
  
    mounted() {
      this.PieceworkSetFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getAllCategory()
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      getAllCategory() {
        getAllCategory(localStorage.getItem("access")).then((res) => {
                this.category = res.data.data
                //  this.total = Number(res.data.data.total)
            })
        },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        selectPieceworkSet(this.currentPage, this.pageSize, this.PieceworkSetFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addPieceworkSet(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
   //修改
   editAccount() {
    upPieceworkSet(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeletePieceworkSet(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.PieceworkSetFindDTO.startTime = e[0]
          this.PieceworkSetFindDTO.endTime = e[1]
        } else if (!e) {
          this.PieceworkSetFindDTO.startTime = ''
          this.PieceworkSetFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .btn-style{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  </style>
  